import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import GameLauncher from './GameLauncher';
import SelfEvaluation from './SelfEvaluation';
import AnalyticsStatsPage from './AnalyticsStats';
import DotmanImagePage from './DotmanImage';
import { analyticsTracker } from './utils/AnalyticsTracker';

// Component to track route changes
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track visit on route change (async)
    analyticsTracker.trackVisit(location.pathname).catch(err => {
      console.warn('Failed to track visit:', err);
    });
  }, [location.pathname]);

  return null;
}

function App() {
  const [showLauncher, setShowLauncher] = useState(true);

  const handleBackToLauncher = () => {
    setShowLauncher(true);
  };

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route
          path="/"
          element={
            showLauncher ? (
              <GameLauncher onBackToLauncher={handleBackToLauncher} />
            ) : null
          }
        />
        <Route path="/self-evaluation" element={<SelfEvaluation />} />
        <Route path="/admin/stats" element={<AnalyticsStatsPage />} />
        <Route path="/admin/dotman" element={<DotmanImagePage />} />
      </Routes>
    </Router>
  );
}

export default App;